<template>
  <v-container fluid grid-list-xs>

    <AccountTerminalDebug :terminal="selectedTerminal"></AccountTerminalDebug>

    <v-expansion-panel
      v-model="panel"
      expand
      multiple
      class="elevation-0"
    >
      <v-expansion-panel-content>
        <div slot="header" class="title font-weight-medium">
          <v-chip
            pill
            color="primary"
          >
            <h3 class="white--text">1</h3>
          </v-chip>
          Details
        </div>
        <v-card>
          <v-card-text>
            <v-layout row>
              <v-flex xs11 md10>
                <v-layout row wrap>
                  <v-flex xs2 class="primary--text">Billing:</v-flex>
                  <v-flex xs4>
                    <span v-if="transaction.billing_name">{{ transaction.billing_name }}</span>
                    <span v-if="transaction.billing_address"> {{ transaction.billing_address }}</span>
                    <span v-if="transaction.billing_city || transaction.billing_state || transaction.billing_postal_code">
                      {{ transaction.billing_city }},
                      {{ transaction.billing_state }}
                      {{ transaction.billing_postal_code }}
                    </span>
                  </v-flex>
                  <v-flex xs2 class="primary--text">Start:</v-flex>
                  <v-flex xs4>{{ transaction.recurring_start ? dateUtc(transaction.recurring_start) : '-' }}</v-flex>

                  <v-flex xs2 class="primary--text">Amount:</v-flex>
                  <v-flex xs4>{{ money(custom.total_amount / 100) }}</v-flex>
                  <v-flex xs2 class="primary--text">Status:</v-flex>
                  <v-flex xs4 class="text-capitalize">{{ transaction.recurring_status }}</v-flex>

                  <template v-if="parsedCustom && parsedCustom.migrated_to_schedule_id && hasPermission('can_view_migration')">
                    <v-flex xs2 class="primary--text">Migration:</v-flex>
                    <v-flex xs4>
                      <router-link :to="'/pnx_installments/manage?id=' + parsedCustom.migrated_to_schedule_id">
                        <v-chip small outline color="info">Migrated to PNX #{{ parsedCustom.migrated_to_schedule_id }}</v-chip>
                      </router-link>
                    </v-flex>
                  </template>

                  <v-flex xs2 class="primary--text">Downpayment:</v-flex>
                  <v-flex xs4>
                    {{ money((downpaymentTransaction.total_amount - downpaymentTransaction.fee_amount) / 100) }}
                    <span class="pl-2 primary--text" style="cursor:pointer;" @click="showDownpaymentPriceAdjustmentFee=true" v-if="selectedTerminal.is_cashdiscount && transaction.request_type !== 'ach' && !showDownpaymentPriceAdjustmentFee && !transaction.is_fee_waived">Price Adj Fee &or;</span>
                    <span class="pl-2 primary--text" style="cursor:pointer;" @click="showDownpaymentPriceAdjustmentFee=false" v-if="selectedTerminal.is_cashdiscount && transaction.request_type !== 'ach' && showDownpaymentPriceAdjustmentFee && !transaction.is_fee_waived">{{ money((downpaymentTransaction.fee_amount) / 100) }} &and;</span>
                  </v-flex>
                  <v-flex xs2 class="primary--text">Installment Amount:</v-flex>
                  <v-flex xs4>
                    {{ money(((transaction.modify_total_amount ? transaction.modify_total_amount : transaction.total_amount) - (transaction.modify_fee_amount ? transaction.modify_fee_amount : transaction.fee_amount)) / 100) }}
                    <span class="pl-2 primary--text" style="cursor:pointer;" @click="showAmountPriceAdjustmentFee=true" v-if="selectedTerminal.is_cashdiscount && transaction.request_type !== 'ach' && !showAmountPriceAdjustmentFee && !transaction.is_fee_waived">Price Adj Fee &or;</span>
                    <span class="pl-2 primary--text" style="cursor:pointer;" @click="showAmountPriceAdjustmentFee=false" v-if="selectedTerminal.is_cashdiscount && transaction.request_type !== 'ach' && showAmountPriceAdjustmentFee && !transaction.is_fee_waived">{{ money((transaction.modify_fee_amount ? transaction.modify_fee_amount : transaction.fee_amount) / 100) }} &and;</span>
                  </v-flex>

                  <!--
                  <v-flex xs2 class="primary--text">Rem Balance: {{ money(remainingBalance) }}</v-flex>
                  <v-flex xs4>{{ money(totalAmountSettledLessFee / 100) }} PAID/SETTLED</v-flex>
                  -->
                  <v-flex xs2 class="primary--text">Paid / Settled:</v-flex>
                  <v-flex xs4>{{ money(totalAmountSettledLessFee / 100) }}</v-flex>
                  <v-flex xs2 class="primary--text">Finish Date:</v-flex>
                  <v-flex xs4>
                    <span v-if="finalTransaction.hasOwnProperty('future_post')">{{ dateUtc(finalTransaction.future_post) }}</span>
                    <span v-else-if="transaction.modify_recurring_end">{{(transaction.modify_recurring_end === '2099-12-31T00:00:00.000Z') ? 'ongoing' : dateUtc(transaction.modify_recurring_end)}}</span>
                    <span v-else>{{(!transaction.recurring_end) ? '-' : (transaction.recurring_end === '2099-12-31T00:00:00.000Z') ? 'ongoing' : dateUtc(transaction.recurring_end)}}</span>
                  </v-flex>

                  <v-flex xs2 class="primary--text">Payments:</v-flex>
                  <v-flex xs4>{{ remainingPaymentCount }} remaining</v-flex>
                  <v-flex xs3><span class="primary--text">{{ transaction.payment_type ? transaction.payment_type.toUpperCase() : '' }}:</span> **** **** **** {{ transaction.last_four }}</v-flex>
                  <v-flex xs3>
                    <template v-if="transaction.payment_type !== 'ach'">
                      <span class="primary--text">Exp Date:</span> {{ expiration(transaction.card_expiration) }}
                    </template>
                  </v-flex>

                  <template v-if="transaction.order_number">
                    <v-flex xs2 hidden-md-and-up class="primary--text">Order Number:</v-flex>
                    <v-flex xs4 hidden-md-and-up >{{ transaction.order_number }}</v-flex>
                  </template>
                  <template v-if="transaction.customer_po">
                    <v-flex xs2 hidden-md-and-up class="primary--text">Customer PO:</v-flex>
                    <v-flex xs4 hidden-md-and-up>{{ transaction.customer_po }}</v-flex>
                  </template>
                  <template v-if="transaction.custom_field_1">
                    <v-flex xs2 hidden-md-and-up class="primary--text">Custom 1:</v-flex>
                    <v-flex xs4 hidden-md-and-up>{{ transaction.custom_field_1 }}</v-flex>
                  </template>
                  <template v-if="transaction.custom_field_2">
                    <v-flex xs2 hidden-md-and-up class="primary--text">Custom 2:</v-flex>
                    <v-flex xs4 hidden-md-and-up>{{ transaction.custom_field_2 }}</v-flex>
                  </template>
                  <template v-if="transaction.custom_field_3">
                    <v-flex xs2 hidden-md-and-up class="primary--text">Custom 3:</v-flex>
                    <v-flex xs4 hidden-md-and-up>{{ transaction.custom_field_3 }}</v-flex>
                  </template>
                </v-layout>
              </v-flex>

              <v-flex md3 hidden-sm-and-down v-if="transaction.order_number || transaction.customer_po || transaction.custom_field_1 || transaction.custom_field_2 || transaction.custom_field_3">
                <v-layout row wrap>
                  <template v-if="transaction.order_number">
                    <v-flex xs5 class="primary--text">Order Number:</v-flex>
                    <v-flex xs7>{{ transaction.order_number }}</v-flex>
                  </template>
                  <template v-if="transaction.customer_po">
                    <v-flex xs5 class="primary--text">Customer PO:</v-flex>
                    <v-flex xs7>{{ transaction.customer_po }}</v-flex>
                  </template>
                  <template v-if="transaction.custom_field_1">
                    <v-flex xs5 class="primary--text">Custom 1:</v-flex>
                    <v-flex xs7>{{ transaction.custom_field_1 }}</v-flex>
                  </template>
                  <template v-if="transaction.custom_field_2">
                    <v-flex xs5 class="primary--text">Custom 2:</v-flex>
                    <v-flex xs7>{{ transaction.custom_field_2 }}</v-flex>
                  </template>
                  <template v-if="transaction.custom_field_3">
                    <v-flex xs5 class="primary--text">Custom 3:</v-flex>
                    <v-flex xs7>{{ transaction.custom_field_3 }}</v-flex>
                  </template>
                </v-layout>
              </v-flex>

              <v-flex shrink>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn icon flat small color="primary" @click="printSchedule" class="ma-0 pa-0" v-on="on">
                      <v-icon>fa-print</v-icon>
                    </v-btn>
                  </template>
                  <span>Print Schedule</span>
                </v-tooltip>
              </v-flex>
            </v-layout>
            <v-divider class="primary"></v-divider>
          </v-card-text>

          <v-card-actions>
            <v-btn block flat outline color="primary" @click="viewSchedule" class="overflow-button"><span>View Installments</span></v-btn>
            <v-btn block flat outline color="primary" @click="cancelPlan" class="overflow-button" :disabled="!remainingPaymentCount"><span>Cancel Installments</span></v-btn>
            <v-btn block flat outline color="primary" @click="takePayment" class="overflow-button" :disabled="!remainingPaymentCount"><span>Take Payment</span></v-btn>
            <v-btn block flat outline color="primary" @click="modifyPlan" class="overflow-button" :disabled="!remainingPaymentCount"><span>Modify / Change</span></v-btn>
          </v-card-actions>
        </v-card>
      </v-expansion-panel-content>

      <v-expansion-panel-content>
        <div slot="header" class="title font-weight-medium">
          <v-chip
            pill
            color="primary"
          >
            <h3 class="white--text">2</h3>
          </v-chip>
          Schedule of Installments
        </div>

        <Schedule :terminal="selectedTerminal" :transactions="transactions" :transaction="transaction"></Schedule>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-dialog v-model="payModal" maxWidth="785px" persistent @keydown.esc.prevent="closePayModal" @input="v => v || closePayModal">
      <v-toolbar dense>
        <v-toolbar-title>
          TAKE <span class="font-weight-thin">PAYMENT</span>
          <template v-if="payStep === 2">
            <span class="font-weight-thin">IN <span class="primary--text">FULL</span></span>
          </template>
        </v-toolbar-title>

        <v-spacer></v-spacer>
        <span class="subheading"><span class="primary--text">Remaining balance</span> to pay <span class="caption" v-if="selectedTerminal.is_cashdiscount && transaction.request_type !== 'ach' && !transaction.is_fee_waived">(including Price Adj Fee) </span>is <span class="font-weight-medium">{{ money(remainingBalanceWithFee) }}</span></span>

        <v-btn icon flat color="primary" @click="closePayModal">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-window v-model="payStep">
        <v-window-item :value="1">
          <v-card>
            <v-card-text fill-height>
              You have selected TAKE PAYMENT. The following options are available to you. Each has important implications. Please click checkbox.
              <v-checkbox
                label="Take ONE payment in FULL to clear account"
                v-model="payType[0]"
                class="ml-4"
                @click.native.stop="payTypeChanged($event, 0)"
                color="primary"
                dense
                :disabled="!remainingPaymentCount"
                hide-details
              ></v-checkbox>
              <v-checkbox
                label="Take additional payment (amount can vary) or reduce monthly amount/schedule"
                v-model="payType[1]"
                class="ml-4"
                @click.native.stop="payTypeChanged($event, 1)"
                color="primary"
                dense
                hide-details
              ></v-checkbox>
              <v-layout row wrap justify-end mt-4>
                <v-btn class="primary" @click="setPayStep">OK</v-btn>
                <v-btn @click="closePayModal">Cancel</v-btn>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-window-item>

        <v-window-item :value="2">
          <v-card>
            <Payment :terminal="selectedTerminal" :transactions="transactions" :transaction="transaction" :finalTransaction="finalTransaction" :amountRemaining="remainingBalanceWithFee" :payFull="true"></Payment>
          </v-card>
        </v-window-item>

        <v-window-item :value="3">
          <v-card>
            <Payment :terminal="selectedTerminal" :transactions="transactions" :transaction="transaction" :amountRemaining="remainingBalanceWithFee" :payFull="false"></Payment>
          </v-card>
        </v-window-item>

        <v-window-item :value="4">
          <!-- <ModifyPayment :transaction="downpaymentTransaction" v-if="downpaymentTransaction.settled && !downpaymentTransaction.refunded"/> -->
        </v-window-item>

        <v-window-item :value="5">
          There was an error
        </v-window-item>
      </v-window>
    </v-dialog>

    <v-dialog v-model="modifyModal" maxWidth="750px" persistent @keydown.esc.prevent="closeModifyModal" @input="v => v || closeModifyModal">
      <v-toolbar dense>
        <v-toolbar-title>
          <template v-if="modifyStep === 2">MODIFY <span class="font-weight-light">INSTALLMENT <span class="primary--text">PAYMENT</span></span></template>
          <template v-else-if="modifyStep === 3">MODIFY <span class="font-weight-light">BILLING <span class="primary--text">ADDRESS</span></span></template>
          <template v-else-if="modifyStep === 4">MODIFY <span class="font-weight-light">PAYMENT <span class="primary--text">INFORMATION</span></span></template>
          <template v-else>MODIFY / CHANGE</template>
        </v-toolbar-title>

        <v-spacer></v-spacer>
        <span class="font-weight-light title">{{ transaction.card_name }}</span>

        <v-btn icon flat color="primary" @click="closeModifyModal">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-window v-model="modifyStep">
        <v-window-item :value="1">
          <v-card>
            <v-card-text fill-height>
              You have selected MODIFY / CHANGE. The following options are available to you. Each has important implications. Please click checkbox. Press OK to continue.
              <v-checkbox
                label="MODIFY Installment Schedule"
                v-model="modifyType[0]"
                class="ml-4"
                @click.native.stop="modifyTypeChanged($event, 0)"
                color="primary"
                dense
                hide-details
              ></v-checkbox>
              <v-checkbox
                label="MODIFY Billing Address / Email"
                v-model="modifyType[1]"
                class="ml-4"
                @click.native.stop="modifyTypeChanged($event, 1)"
                color="primary"
                dense
                hide-details
              ></v-checkbox>
              <v-checkbox
                label="MODIFY Payment Information"
                v-model="modifyType[2]"
                class="ml-4"
                @click.native.stop="modifyTypeChanged($event, 2)"
                color="primary"
                dense
                hide-details
              ></v-checkbox>
              <v-layout row wrap justify-end mt-4>
                <v-btn class="primary" @click="setModifyStep">OK</v-btn>
                <v-btn @click="closeModifyModal">Cancel</v-btn>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-window-item>

        <v-window-item :value="2">
          <v-card>
            <ModifyInstallments v-if="transactions" :terminal="selectedTerminal" :transaction="transaction" :finalTransaction="finalTransaction" :scheduledTransactions="scheduledTransactions" :custom="custom" ></ModifyInstallments>
          </v-card>
        </v-window-item>

        <v-window-item :value="3">
          <v-card>
            <ModifyBilling v-if="transaction" :terminal="selectedTerminal" :transaction="transaction"></ModifyBilling>
          </v-card>
        </v-window-item>

        <v-window-item :value="4">
          <v-card>
            <ModifyPayment v-if="transaction" :terminal="selectedTerminal" :transaction="transaction" :finalTransaction="finalTransaction"></ModifyPayment>
          </v-card>
        </v-window-item>

        <v-window-item :value="5">
          There was an error
        </v-window-item>
      </v-window>
    </v-dialog>

    <SchedulePrint ref="schedule" :transaction="transaction" :downpayment="downpaymentTransaction" :final="finalTransaction" :paymentcount="originalPaymentCount" :custom="custom"></SchedulePrint>
  </v-container>
</template>

<script>
import Moment from 'moment'
import VueJsonPrettyWrapper from '@/components/VueJsonPrettyWrapper.vue'

import Bus from '@/bus'

import ApiMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import CashDiscountMixin from '@/mixins/cashDiscount'
import DisplayMixin from '@/mixins/display'
import PlansMixin from '@/mixins/plans'
import RecurringMixin from '@/mixins/recurring'
import StoreMixin from '@/store/mixin'
import UtilityMixin from '@/mixins/utility'

import AccountTerminalDebug from '@/components/terminal/components/AccountTerminalDebug.vue'
import ModifyBilling from '@/components/plans/ModifyBilling.vue'
import ModifyInstallments from '@/components/plans/ModifyInstallments.vue'
import ModifyPayment from '@/components/plans/ModifyPayment.vue'
import Payment from '@/components/plans/Payment.vue'
import Schedule from '@/components/plans/Schedule.vue'
import SchedulePrint from '@/components/plans/SchedulePrint.vue'

export default {
  mixins: [ApiMixin, AuthMixin, CashDiscountMixin, DisplayMixin, PlansMixin, RecurringMixin, StoreMixin, UtilityMixin],
  components: {AccountTerminalDebug, ModifyBilling, ModifyInstallments, ModifyPayment, Payment, Schedule, SchedulePrint, VueJsonPrettyWrapper},

  data: function () {
    return {
      enabled: false,
      panel: [true, false, false],

      // terminal: null,
      selectedTerminal: {},
      card_terminal_id: null,
      ach_terminal_id: null,

      custom: {},
      transactions: [],
      transaction: {},
      downpaymentTransaction: {},
      finalTransaction: {},
      scheduledTransactions: [],
      approvedTransactions: [],

      showDownpaymentPriceAdjustmentFee: false,
      showAmountPriceAdjustmentFee: false,
      showFinalPriceAdjustmentFee: false,

      payModal: false,
      payType: [true, false, false],
      payStep: 1,
      modifyModal: false,
      modifyType: [true, false, false],
      modifyStep: 1
    }
  },

  beforeDestroy () {
    Bus.$off('closeModifyModal')
    Bus.$off('showModifyModal')
    Bus.$off('closePayModal')
    Bus.$off('reloadPlan')
  },

  mounted () {
    Bus.$on('closeModifyModal', this.closeModifyModal)
    Bus.$on('showModifyModal', this.modifyPlan)
    Bus.$on('closePayModal', this.closePayModal)
    Bus.$on('reloadPlan', this.load)

    this.load()
  },

  computed: {
    parsedCustom () {
      try {
        if (!this.transaction.custom) return null
        if (typeof this.transaction.custom === 'object') return this.transaction.custom
        return JSON.parse(this.transaction.custom)
      } catch (e) {
        return null
      }
    },

    environment () {
      return process.env.NODE_ENV
    },

    terminal: {
      get () {
        if (this.transaction.payment_type === 'ach') {
          return this.ach_terminal_id
        } else {
          return this.card_terminal_id
        }
      },
      set (value) {
        if (this.transaction.payment_type === 'ach') {
          let terminal = this.terminalsACHCanCharge.find(terminal => terminal.terminal_id === value)
          if (terminal) {
            this.ach_terminal_id = value
            this.selectedTerminal = terminal
          }
        } else {
          let terminal = this.terminalsCardCanCharge.find(terminal => terminal.terminal_id === value)
          if (terminal) {
            this.card_terminal_id = value
            this.selectedTerminal = terminal
          }
        }
      }
    },

    associatedSorted: function () {
      if (!this.transaction) {
        return false
      }
      // @TODO are we killing reactivity... do we care?
      return [...this.transaction.associatedTransactions].reverse()
    },

    totalAmountSettledLessFee: function () {
      // let totalSettled = 0

      let totalSettled = this.transactions.reduce((runningTotal, transaction) => {
        let childrenTotalSettled = 0
        if (transaction.hasOwnProperty('associatedTransactions') && transaction.associatedTransactions.length) {
          childrenTotalSettled = this.transaction.associatedTransactions.reduce((childRunningTotal, childTransaction) => {
            if ((childTransaction.request_type === 'sale' || childTransaction.request_type === 'ach') && childTransaction.response_code === '000' && childTransaction.settled && childTransaction.parent_transaction_id === this.transaction.id) {
              return childRunningTotal + (childTransaction.total_amount - childTransaction.fee_amount)
            } else if ((childTransaction.request_type === 'credit' || childTransaction.request_type === 'achcredit') && childTransaction.response_code === '000' && childTransaction.settled && childTransaction.parent_transaction_id === this.transaction.id) {
              return childRunningTotal - (childTransaction.total_amount - childTransaction.fee_amount)
            }

            return childRunningTotal
          }, 0)
        }

        if ((transaction.request_type === 'sale' || transaction.request_type === 'ach') && transaction.response_code === '000' && transaction.settled) {
          return runningTotal + ((transaction.modify_total_amount ? transaction.modify_total_amount : transaction.total_amount) - (transaction.modify_fee_amount ? transaction.modify_fee_amount : transaction.fee_amount))
        } else if ((transaction.request_type === 'credit' || transaction.request_type === 'achcredit') && transaction.response_code === '000' && transaction.settled) {
          return runningTotal - ((transaction.modify_total_amount ? transaction.modify_total_amount : transaction.total_amount) - (transaction.modify_fee_amount ? transaction.modify_fee_amount : transaction.fee_amount))
        }

        return runningTotal + childrenTotalSettled
      }, 0)

      return totalSettled
    },

    remainingBalance: function () {
      let subtotal = ((this.transaction.modify_total_amount ? this.transaction.modify_total_amount : this.transaction.total_amount) - (this.transaction.modify_fee_amount ? this.transaction.modify_fee_amount : this.transaction.fee_amount)) / 100 * this.scheduledTransactions.length

      // if (!this.transaction.voided && !this.transaction.settled && this.transaction.response_text === 'PENDING') {
      //   subtotal += (this.transaction.modify_total_amount ? this.transaction.modify_total_amount : this.transaction.total_amount) - (this.transaction.modify_fee_amount ? this.transaction.modify_fee_amount : this.transaction.fee_amount) / 100
      // }

      if (this.finalTransaction.hasOwnProperty('total_amount') && this.finalTransaction.total_amount && !this.finalTransaction.settled) {
        subtotal += ((this.finalTransaction.modify_total_amount ? this.finalTransaction.modify_total_amount : this.finalTransaction.total_amount) - (this.finalTransaction.modify_fee_amount ? this.finalTransaction.modify_fee_amount : this.finalTransaction.fee_amount)) / 100
      }

      return Number(subtotal)
    },

    remainingBalanceWithFee: function () {
      let subtotal = ((this.transaction.modify_total_amount ? this.transaction.modify_total_amount : this.transaction.total_amount) - (this.transaction.modify_fee_amount ? this.transaction.modify_fee_amount : this.transaction.fee_amount)) / 100 * this.scheduledTransactions.length

      // if (!this.transaction.voided && !this.transaction.settled && this.transaction.response_text === 'PENDING') {
      //   subtotal += (this.transaction.modify_total_amount ? this.transaction.modify_total_amount : this.transaction.total_amount) / 100
      // }

      if (this.finalTransaction.hasOwnProperty('total_amount') && this.finalTransaction.total_amount && !this.finalTransaction.settled) {
        subtotal += ((this.finalTransaction.modify_total_amount ? this.finalTransaction.modify_total_amount : this.finalTransaction.total_amount) - (this.finalTransaction.modify_fee_amount ? this.finalTransaction.modify_fee_amount : this.finalTransaction.fee_amount)) / 100
      }

      if (!this.selectedTerminal.is_cashdiscount || this.transaction.request_type === 'ach' || this.transaction.is_fee_waived) {
        return Number(subtotal)
      } else {
        return Number(subtotal) + Number(this.calculateFee(this.selectedTerminal, subtotal))
      }
    },

    remainingPaymentCount: function () {
      // @TODO This method doesn't account for multiple recurring or future pending
      // @TODO Need to take into account if they scheduled past a batch time or have settled transactions in the schedule that can be "crossed off"

      let subtotal = this.scheduledTransactions.length

      if (this.finalTransaction.hasOwnProperty('total_amount') && this.finalTransaction.total_amount && !this.finalTransaction.settled && !this.finalTransaction.voided) {
        subtotal++
      }

      // !props.item.settled && props.item.response_code === '000' && props.item.response_text === 'PENDING'">Pending
      // if (!this.transaction.voided && !this.transaction.settled && this.transaction.response_text === 'PENDING') {
      //   subtotal++
      // }

      return subtotal
    },

    originalPaymentCount: function () {
      let subtotal = this.getAllInstallments(this.transaction.recurring_type, this.transaction.recurring_start, this.transaction.recurring_end).length

      if (this.finalTransaction.hasOwnProperty('total_amount') && this.finalTransaction.total_amount) {
        subtotal++
      }

      return subtotal
    }
  },

  methods: {
    async load () {
      Bus.$emit('openWaitModal')

      this.terminal = this.terminalsCardCanCharge[0].terminal_id

      let groupId = this.$route.query.id

      if (!groupId && this.$route.query.transaction_id) {
        try {
          let txnData = await this.api({url: '/transactions/' + this.$route.query.transaction_id})
          groupId = txnData.data.transaction.transaction_group_custom_tracking_id
        } catch (err) {
          Bus.$emit('closeWaitModal')
          Bus.$emit('openModal', {
            status: 'error',
            message: 'Unable to resolve transaction'
          })
          return false
        }
      }

      if (!groupId) {
        Bus.$emit('openModal', {
          status: 'error',
          message: 'Invalid transaction'
        })
        return false
      }

      let data = await this.api({url: `/plans/${groupId}`})

      if (data.data.group.custom && typeof data.data.group.custom === 'object' && data.data.group.custom !== null) {
        this.custom = data.data.group.custom
      }

      this.transactions = data.data.group.transactions

      this.transaction = [...this.transactions].reverse().find(transaction => ((transaction.request_type === 'sale' && transaction.response_code === '000') || transaction.request_type === 'ach') && transaction.api_method !== 'cron' && transaction.authorized !== null && transaction.voided === null && transaction.is_recurring === 1 && transaction.modify_recurring_type !== 'none') || {}

      // if no ongoing recurring, pull the most recent valid transaction
      // @TODO What to do if initial transaction failed, need to show merchant plan is cancelled
      // @TODO this is _very_ hacky, need a better way to have central info vs ongoing transactions
      // ACH could be failed but will be still running... how do we represent that?
      if (!Object.keys(this.transaction).length) {
        this.transaction = [...this.transactions].reverse().find(transaction => ((transaction.request_type === 'sale') || transaction.request_type === 'ach') && transaction.api_method !== 'cron' && transaction.is_recurring === 1) || {}
      }

      this.terminal = this.transaction.terminal_id

      if (!Object.keys(this.transaction).length || this.transaction.voided !== null) {
        this.scheduledTransactions = []
      } else {
        let allScheduledTransactions = this.getInstallments(this.transaction)

        // cross off any processed transactions from scheduled...
        this.scheduledTransactions = allScheduledTransactions.filter(function (value, index, array) {
          let now = Moment.utc().subtract(1, 'days')
          if (Moment(value).isAfter(now) && !this.transaction.associatedTransactions.find(child => Moment(child.authorized).format('YYYY-MM-DD') === value.format('YYYY-MM-DD'))) {
            return value
          }
        }, this)
      }

      // single payment transactions
      this.transactions.sort((a, b) => (Moment(a.created) > Moment(b.created)) ? 1 : -1)

      this.downpaymentTransaction = data.data.group.transactions.find(transaction => (transaction.request_type === 'sale' || transaction.request_type === 'ach') && transaction.api_method !== 'cron' && transaction.voided === null && transaction.is_recurring === 0 && transaction.future_post === null) || {}

      this.transactions.sort((a, b) => (Moment(a.future_post) > Moment(b.future_post)) ? 1 : -1)

      this.finalTransaction = [...data.data.group.transactions].reverse().find(transaction => (transaction.request_type === 'sale' || transaction.request_type === 'ach') && transaction.api_method !== 'cron' && transaction.voided === null && transaction.is_recurring === 0 && transaction.future_post !== null) || {}

      if (this.transaction.hasOwnProperty('custom') && this.transaction.custom) {
        this.transaction.custom = JSON.parse(this.transaction.custom)
      }

      if (this.downpaymentTransaction.hasOwnProperty('custom') && this.downpaymentTransaction.custom) {
        this.downpaymentTransaction.custom = JSON.parse(this.downpaymentTransaction.custom)
      }

      if (this.finalTransaction.hasOwnProperty('custom') && this.finalTransaction.custom) {
        this.finalTransaction.custom = JSON.parse(this.finalTransaction.custom)
      }

      // disabled pay in full option if nothing to pay off
      if (!this.remainingPaymentCount) {
        this.payType = [false, true, false]
      }

      Bus.$emit('closeWaitModal')
    },

    printSchedule () {
      this.$refs.schedule.print()
    },

    viewSchedule () {
      this.$set(this.panel, 1, true)
    },

    async cancelPlan () {
      if (!this.transactions) {
        throw new Error('Unable to identify transactions')
      }

      if (!confirm('Cancelling is not reversable, are you absolutely sure you would like to cancel this recurring schedule?')) {
        return
      }

      await this.cancelAllPendingTransactions(this.transactions)
    },

    takePayment () {
      this.payModal = true
    },

    payTypeChanged (value, id) {
      if (id === 0) {
        this.payType = [true, false, false]
      } else if (id === 1) {
        this.payType = [false, true, false]
      } else if (id === 2) {
        this.payType = [false, false, true]
      }
    },

    setPayStep () {
      if (this.payType[0]) {
        this.payStep = 2
      } else if (this.payType[1]) {
        this.payStep = 3
      } else if (this.payType[2]) {
        this.payStep = 4
      }
    },

    closePayModal () {
      this.payStep = 1
      this.payModal = false
    },

    modifyPlan () {
      this.modifyModal = true
    },

    modifyTypeChanged (value, id) {
      if (value && id === 0) {
        this.modifyType = [true, false, false]
      } else if (value && id === 1) {
        this.modifyType = [false, true, false]
      } else if (value && id === 2) {
        this.modifyType = [false, false, true]
      }
    },

    setModifyStep () {
      if (this.modifyType[0]) {
        this.modifyStep = 2
      } else if (this.modifyType[1]) {
        this.modifyStep = 3
      } else if (this.modifyType[2]) {
        this.modifyStep = 4
      }
    },

    closeModifyModal () {
      this.modifyStep = 1
      this.modifyModal = false
    }
  }
}
</script>

<style lang="less">
  .v-expansion-panel__container {
    margin: 5px;
  }
  .v-expansion-panel__header {
    background: var(--v-secondary-base) !important;
    padding: 5px;
  }

  .overflow-button {
    padding-bottom: 20px;
    padding-left: 5px;
    padding-right: 5px;
    padding-top: 20px;
  }

  .overflow-button .v-btn__content span {
    overflow: hidden;
    text-overflow: ellipsis !important;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/components/plans/Manage.vue